import { getOfferBlockMappings } from 'app/features/offer/blocks/block-mappings'
import { getArticleBlockMappings } from './block-mappings'
import { BlockRenderer, BlockRendererProps } from 'app/features/shared/blocks'

export const ArticleBlockRenderer = (props: BlockRendererProps) => {
  const combinedMappings = {
    ...getOfferBlockMappings(),
    ...getArticleBlockMappings(),
  }

  return <BlockRenderer {...props} additionalComponents={combinedMappings} />
}
